import React, { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'

import './App.css'
import UserList from 'pages/UserList'
import { View } from 'components/View'

const FavoriteList = React.lazy(() => import('pages/FavoriteList'))

const LoaderView = () => <div>Loading...</div>

function App () {
  return (
    <View flex style={{ alignItems: 'center' }}>
      <View style={{ width: '100%', maxWidth: 1200 }}>
        <Suspense fallback={<LoaderView />}>
          <Routes>
            <Route path='/' element={<UserList />} />
            <Route path='/favorites' element={<FavoriteList />} />
          </Routes>
        </Suspense>
      </View>
    </View>
  )
}

export default App
